import React, { FC } from 'react'

export type Props = {
  image?: string | null
  product?: Product | null
}

export type Product = {
  tags?: string[]
  title?: string
}

export const Item: FC<Props> = ({ image, product }) => {
  const name = product?.tags?.filter(function (tag) {
    return tag.includes('finish:')
  })[0]

  if (product == null) {
    return null
  }

  return (
    <div className="Visualizer-item">
      <div
        className="Visualizer-itemImage"
        style={{ backgroundImage: image ? `url('${image}')` : undefined }}
      ></div>
      <div className="Visualizer-itemContent">
        <p className="Visualizer-itemTitle">{product.title}</p>
        <p className="Visualizer-itemText">in {name?.replace('finish:', '')}</p>
      </div>
    </div>
  )
}
